<template>
  <div class="list-header-wrapper">
    <div class="list-title list-item">{{ listTitle }}</div>
    <div v-if="showVipMessage" class="list-content list-item">
      <!--      <div class="num-info list-content-item">
        已上传<span class="yellow">{{ alreadyUse }}M</span>,共 <span class="yellow">{{ total }}</span>
      </div>-->
      <div v-if="isVip" class="vipMsn list-content-item">
        您已开通{{ vipName }}，到期时间<span class="yellow">{{ dueTime }}</span>
        <span class="ImmedPay" @click="ImmedPay">立即续费</span>
      </div>
      <div v-else class="capacity openMem list-content-item" @click="ImmedPay">开通会员</div>
      <el-popover v-model="visible">
        <div class="detail-wrap">
          <p>
            <span class="text-wrapper">
              <span>空间余量：{{ space.surplus }}G</span><span>已使用：{{ space.used }}G / {{ space.limit }}G</span>
            </span>
            <el-progress :text-inside="true" :percentage="space.percentage" color="#df5813" :stroke-width="6" :show-text="false"></el-progress>
          </p>
          <!--<p>
            <span class="text-wrapper">
              <span>访问余量：{{ view.surplus }}次</span><span>已使用：{{ view.used }}次 / {{ view.limit }}次</span>
            </span>
            <el-progress :text-inside="true" :percentage="view.percentage" color="#df5813" :stroke-width="6" :show-text="false"></el-progress>
          </p>-->
          <p>
            <span class="text-wrapper">
              <span>流量余量：{{ flow.surplus }}G</span><span>已使用：{{ flow.used }}G / {{ flow.limit }}G</span>
            </span>
            <el-progress :text-inside="true" :percentage="flow.percentage" color="#df5813" :stroke-width="6" :show-text="false"></el-progress>
          </p>
          <div v-if="flow.used < 0" class="exceed">
            <span class="main-color">您已用超{{ flow.used | VALUE_INT }}G</span>
            <p>*流量超出后影响作品的正常访问，请及时购买流量</p>
          </div>
          <div class="capacity " v-if="isChild != 1">
            <span @click="openMem">扩容</span>
          </div>
        </div>
        <div slot="reference" class="capacity list-content-item margin">余量查看</div>
      </el-popover>
    </div>
    <!--    <div class="list-search-container" v-if="isSearch">
      <el-input placeholder="输入作品名称" v-model="queryTitle">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <span class="search" @click="query(queryTitle)">搜索</span>
      <span class="reset" type="info" size="mini" @click="query('')">重置</span>
    </div>-->
    <div class="righter">
      <div class="list-search-container" v-if="isSearch">
        <span class="search" @click="showSearch = !showSearch">搜索</span>
      </div>
      <div class="batch-download-btn" @click="handleBatchDownloadBtnClick" v-if="showSwitch == 'paper'">批量下载</div>
      <div class="switch-data" v-if="showSwitch">
        <span v-if="showSwitch == 'book' ? isBookChart : isChart">
          <el-tooltip content="缩略图式">
            <img src="@imgs/paper/chart-h@2x.png" alt="缩略图式" @click="switchDataView('chart')" />
          </el-tooltip>
          <el-tooltip content="列表式">
            <img src="@imgs/paper/list@2x.png" alt="列表式" @click="switchDataView('list')" />
          </el-tooltip>
        </span>
        <span v-if="showSwitch == 'book' ? isBookList : isList">
          <el-tooltip content="缩略图式">
            <img src="@imgs/paper/chart@2x.png" alt="缩略图式" @click="switchDataView('chart')" />
          </el-tooltip>
          <el-tooltip content="列表式">
            <img src="@imgs/paper/list-h.png" alt="列表式" @click="switchDataView('list')" />
          </el-tooltip>
        </span>
      </div>
    </div>

    <div class="search-wrapper" v-show="showSearch">
      <div class="search-wrapper__box">
        <span class="label">作品名称:</span>
        <el-input v-model="searchData.queryTitle" class="name">
          <i slot="prefix" class="el-input__icon"></i>
        </el-input>
      </div>
      <div class="search-wrapper__box">
        <span class="label">创建时间:</span>
        <el-date-picker v-model="searchData.createTimeStart" value-format="yyyy-MM-dd" type="date" placeholder="开始日期"> </el-date-picker>
        <span>至</span>
        <el-date-picker v-model="searchData.createTimeEnd" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"> </el-date-picker>
      </div>
      <div class="search-wrapper__box__btn">
        <span class="search" @click="query('search')">搜索</span>
        <span class="reset" type="info" size="mini" @click="query('reset')">重置</span>
      </div>
    </div>
    <el-dialog class="common-dialog build-dialog" title="批量下载" :visible.sync="showBatchDownload" center :modal-append-to-body="false" :close-on-click-modal="false">
      <div class="dialog-input-container">
        <div class="batch-download-form-item">
          <div class="label">
            报纸名称：
          </div>
          <el-select size="mini" v-model="batchDownloadForm.baozhiId" placeholder="请选择">
            <el-option v-for="item in baozhiList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </div>
        <div class="batch-download-form-item">
          <div class="label" v-html="'年&emsp;&emsp;份：'"></div>
          <el-select size="mini" v-model="batchDownloadForm.yearStr" placeholder="请选择">
            <el-option v-for="item in years" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </div>
        <div class="batch-download-form-item">
          <div class="label" v-html="'月&emsp;&emsp;份：'"></div>
          <el-select size="mini" v-model="batchDownloadForm.dateStr" placeholder="请选择">
            <el-option v-for="item in months" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="showBatchDownload = false">取消</el-button>
        <el-button type="primary" size="small" @click="handleBatchDownload" :loading="generateDownLinkLoading">{{ generateDownLinkLoading ? '生成中' : '生成下载链接' }}</el-button>
        <div class="tips">
          提示：生成下载链接后，系统将在后台生成离线数据，预计10分钟后可使用链接地址下载，下载完成后地址将失效。
          <br />
          <br />
          <div v-if="batchDownloadLink">下载链接：{{ batchDownloadLink }}</div>
        </div>
      </div>
    </el-dialog>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions" :appendToBody="true"></tip-dialog>
  </div>
</template>
<script>
import TipDialog from '@components/common/TipDialog.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import compareVipRight from '@components/common/compareVipRight.js'
import home from '@api/home'
import api from '@api/getBook.js'

export default {
  name: 'listHeader',
  mixins: [compareVipRight],
  props: {
    listTitle: { type: String },
    showVipMessage: { default: true },
    showSwitch: {
      type: String,
      default: ''
    }
  },
  components: {
    TipDialog
  },
  data() {
    return {
      showQueryList: ['MyBooks', 'MyBookshelf', 'MyBooklib', 'MyLinkword', 'MyPapers', 'VideoRecommendation'],
      visible: false,
      space: {
        percentage: 0,
        limit: null,
        surplus: null,
        used: null
      },
      view: {
        percentage: 0,
        limit: null,
        surplus: null,
        used: null
      },
      flow: {
        percentage: 0,
        limit: null,
        surplus: null,
        used: null
      },
      showSearch: false,
      queryTitle: '',
      createTimeEnd: '',
      createTimeStart: '',
      searchData: {
        queryTitle: '',
        createTimeEnd: '',
        createTimeStart: ''
      },
      showBatchDownload: false,
      baozhiList: [],
      batchDownloadForm: {
        baozhiId: '',
        yearStr: '',
        dateStr: ''
      },
      years: [],
      months: [
        {
          id: '1',
          name: '1月'
        },
        {
          id: '2',
          name: '2月'
        },
        {
          id: '3',
          name: '3月'
        },
        {
          id: '4',
          name: '4月'
        },
        {
          id: '5',
          name: '5月'
        },
        {
          id: '6',
          name: '6月'
        },
        {
          id: '7',
          name: '7月'
        },
        {
          id: '8',
          name: '8月'
        },
        {
          id: '9',
          name: '9月'
        },
        {
          id: '10',
          name: '10月'
        },
        {
          id: '11',
          name: '11月'
        },
        {
          id: '12',
          name: '12月'
        }
      ],
      batchDownloadLink: '',
      generateDownLinkLoading: false
    }
  },
  filters: {
    VALUE_INT(val) {
      return Math.abs(val)
    }
  },
  computed: {
    ...mapGetters('common', ['userName']),
    alreadyUse() {
      return this.$store.state.manage.alreadyUse || 0
    },
    total() {
      return this.$store.state.manage.allSpace
      // return this.$store.state.common.vipRight.spaceNum
    },
    isVip() {
      return this.$store.state.common.vipInfo.isMember
    },
    vipName() {
      return this.$store.state.common.vipRight.name
    },
    dueTime() {
      //到期时间
      return moment(this.$store.state.common.vipInfo.endTime).format('YYYY-MM-DD HH:mm')
    },
    currentRoute() {
      // return this.$store.state.common.currentRoute
      return this.$store.state.manage.currentManageContent
    },
    isSearch() {
      return this.showQueryList.includes(this.currentRoute)
    },
    isChild() {
      return localStorage.getItem('isChild')
    },
    isChart() {
      return this.$store.state.common.isChart
    },
    isList() {
      return this.$store.state.common.isList
    },
    isBookChart() {
      return this.$store.state.common.isBookChart
    },
    isBookList() {
      return this.$store.state.common.isBookList
    },
    booksCurrentSubAccount() {
      return this.$store.state.manage.booksCurrentSubAccount
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  watch: {
    showBatchDownload(val) {
      if (val) {
        this.getBaoZhiByPage()
      }
    }
  },
  created() {
    this.initYears()
    this.getChildSpaceSum()
  },
  methods: {
    toMember() {
      this.$refs.memberDialog.visible = true
    },
    async handleBatchDownloadBtnClick() {
      //判断是否有权限
      if (await this.compare({ type: 'boole', key: 'downloadHtml' })) {
        this.showBatchDownload = true
      } else {
        this.toMember()
      }
    },
    handleBatchDownload() {
      if (!this.batchDownloadForm.baozhiId) {
        this.$message({
          message: '请选择报系',
          type: 'warning'
        })
        return
      }
      if (!this.batchDownloadForm.yearStr) {
        this.$message({
          message: '请选择年份',
          type: 'warning'
        })
        return
      }
      if (!this.batchDownloadForm.dateStr) {
        this.$message({
          message: '请选择月份',
          type: 'warning'
        })
        return
      }
      this.generateDownLinkLoading = true
      api.generateDownLink(this.batchDownloadForm).then((res) => {
        console.log(res)
        this.generateDownLinkLoading = false
        if (res.status == 200 && res.data && res.data.status == 0) {
          this.batchDownloadLink = res.data.data
          this.$message({
            message: res.data.message,
            type: 'success'
          })
        } else {
          this.$message({
            message: res.data.message,
            type: 'warning'
          })
        }
      })
    },
    initYears() {
      const now = new Date()
      const currentYear = now.getFullYear()
      for (let index = 0; index < 20; index++) {
        this.years.push({
          id: currentYear - index,
          name: currentYear - index + '年'
        })
      }
    },
    getBaoZhiByPage() {
      const params = {
        pageNo: 1,
        pageSize: 100,
        userName: this.booksCurrentSubAccount || this.userName
      }
      api.getBaoZhiByPage(params).then((res) => {
        if (res.status == 200 && res.data && res.data.status == 0) {
          this.baozhiList = res.data.data.content
        }
      })
    },
    // 立即续费
    ImmedPay() {
      let routeUrl = this.$router.resolve({
        path: '/openVIP'
      })
      window.open(routeUrl.href, '_blank')
    },
    // 开通会员
    openMem() {
      if (this.userName) {
        const uploadBaseUrl = process.env.NODE_ENV === 'development' ? location.origin : window.PROJECT_CONFIG.BASE_URL
        const url = uploadBaseUrl + '/product/cloudReadVipBuyUrl.jhtml'
        window.open(url, '_blank')
        // this.$router.push({
        //   path: '/goPayPage',
        //   query: {
        //     buyType: 'elec_book_space'
        //   }
        // })
      } else {
        this.$store.dispatch('common/login')
      }
    },
    query(type) {
      if (type === 'reset') {
        this.searchData.queryTitle = ''
        this.searchData.createTimeEnd = ''
        this.searchData.createTimeStart = ''
      }
      this.$emit('query-list', this.searchData)
    },
    async getChildSpaceSum() {
      await this.$store.dispatch('manage/getSpace')
      this.space.limit = this.total
      this.space.used = (this.alreadyUse / 1024).toFixed(2)
      this.space.surplus = this.total - this.space.used
      if (this.space.used > 0) {
        this.space.percentage = (this.space.used / this.space.limit) * 100
      } else {
        this.space.percentage = 100
      }
    },
    /*getUserPageView() {
      home.getUserPageView().then((res) => {
        let { status, data } = res.data
        if (status === 0) {
          this.view.limit = data.limit
          this.view.used = data.used
          this.view.surplus = this.view.limit - data.used
          if (this.view.used > 0) {
            this.view.percentage = (this.view.used / this.view.limit) * 100
          } else {
            this.view.percentage = 100
          }
        }
      })
    },*/
    getUserNetworkFlow() {
      home.getUserNetworkFlow().then((res) => {
        let { status, data } = res.data
        if (status === 0) {
          this.flow.limit = data.limit
          this.flow.used = (data.used / (1024 * 1024 * 1024)).toFixed(2)
          this.flow.surplus = (this.flow.limit - data.used / (1024 * 1024 * 1024)).toFixed(2)
          if (this.flow.used > 0) {
            this.flow.percentage = (this.flow.used / this.flow.limit) * 100
          } else {
            this.flow.percentage = 100
          }
        }
      })
    },
    switchDataView(type) {
      if (type == 'chart') {
        if (this.listTitle.indexOf('书刊') > -1) {
          this.$store.commit('common/UPDATE_IS_BOOK_CHART', true)
          this.$store.commit('common/UPDATE_IS_BOOK_LIST', false)
        } else {
          this.$store.commit('common/UPDATE_IS_CHART', true)
          this.$store.commit('common/UPDATE_IS_LIST', false)
        }
      } else {
        if (this.listTitle.indexOf('书刊') > -1) {
          this.$store.commit('common/UPDATE_IS_BOOK_LIST', true)
          this.$store.commit('common/UPDATE_IS_BOOK_CHART', false)
        } else {
          this.$store.commit('common/UPDATE_IS_LIST', true)
          this.$store.commit('common/UPDATE_IS_CHART', false)
        }
      }
      // this.$emit('switchDataView', type)
    }
  },
  mounted() {
    // this.$store.dispatch('manage/getSpace')
    // this.getVipInfo()
    // this.getUserPageView()
    this.getUserNetworkFlow()
  }
}
</script>
<style lang="scss" scoped>
.list-header-wrapper {
  padding: 8px 0;
  display: flex;
  flex-flow: row wrap;
  row-gap: 15px;
  column-gap: 10px;
  .list-item {
    display: inline-block;
    .list-content-item {
      display: inline-block;
    }
  }
  .search-wrapper {
    width: 100%;
    display: flex;
    gap: 36px;

    &__box {
      //width: 300px;
      .el-input {
        width: 146px !important;
        /deep/.el-input__inner {
          width: 100%;
          height: 29px;
          padding-left: 30px;
        }
        /deep/.el-input__prefix {
          top: -5px;
        }
      }
      .name {
        width: 242px !important;
        /deep/.el-input__inner {
          padding-left: 5px;
        }
      }
      /deep/.el-date-editor {
        height: 29px;
      }
      /deep/.el-range-input {
        width: 130px;
        margin-left: 3px;
      }
      /deep/.el-range__icon {
        margin-left: -10px;
        margin-bottom: 10px;
      }
      /deep/.el-range-separator {
        margin-bottom: 10px;
      }
      .label {
        margin-right: 10px;
        color: rgba(153, 153, 153, 1);
      }
      span:not(.label) {
        margin: 0 5px;
      }
      &__btn {
        span {
          display: inline-block;
          height: 29px;
          margin-right: 5px;
          cursor: pointer;
          width: 73px;
          color: #fff;
          line-height: 29px;
          background: #df5813;
          font-size: 13px;
          border-radius: 5px;
          text-align: center;
        }
        span.search {
          position: relative;
          left: -3px;
        }
        span:not(.search) {
          background: rgba(153, 153, 153, 1);
        }
      }
    }
  }
  .righter {
    margin-left: auto;
  }
  .list-search-container {
    //width: 320px;
    height: 30px;
    padding-right: 12px;
    display: inline-block;
    /deep/ {
      .el-input {
        width: 170px;
      }
      .el-input__inner {
        height: 24px;
      }
      .el-input__prefix {
        top: -7px;
      }
    }

    span {
      display: inline-block;
      height: 20px;
      margin-right: 5px;
      cursor: pointer;
      width: 80px;
      color: #fff;
      line-height: 20px;
      background: #df5813;
      font-size: 16px;
      border-radius: 5px;
      text-align: center;
    }
    .reset {
      background-color: #999999;
      width: 60px;
      border-radius: 5px;
    }
  }
  .list-title {
    font-size: 18px;
    margin-right: 18px;
  }
  .num-info {
    font-size: 16px;
  }
  .capacity {
    margin-left: 20px;
    font-size: 16px;
    height: 20px;
    width: 60px;
    background: #df5813;
    line-height: 20px;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    span {
    }
  }
  .margin {
    padding: 0 15px;
    width: auto;
    margin-left: 10px;
  }
  .openMem {
    width: 90px;
    background-color: #ff9900;
    margin-left: 15px;
  }
  .vipMsn {
    margin-left: 20px;
    font-size: 16px;
    height: 20px;
    line-height: 18px;
    .ImmedPay {
      line-height: 20px;
      display: inline-block;
      color: #fff;
      background: #df5813;
      margin-left: 10px;
      cursor: pointer;
      width: 95px;
      text-align: center;
      height: 100%;
      border-radius: 5px;
    }
  }
  .switch-data {
    width: 70px;
    display: inline-block;
    vertical-align: top;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
.detail-wrap {
  width: 680px;
  padding: 0 10px;
  p {
    display: flex;
    gap: 20px;
    margin: 0;
    align-items: center;
    font-size: 16px;
    color: #515151;
    line-height: 40px;
    text-align: left;
    .text-wrapper {
      display: inline-block;
      min-width: 340px;
      span {
        display: inline-block;
      }
      span:first-child {
        min-width: 150px;
        margin-right: 5px;
      }
    }
  }
  .exceed {
    p {
      color: #515151;
      color: gray;
      line-height: 25px;
      font-size: 14px;
    }
  }
  .el-progress {
    width: 280px;
  }
  .capacity {
    margin-top: 15px;
    margin-bottom: 10px;
    font-size: 16px;
    text-align: center;
    span {
      display: inline-block;
      height: 20px;
      width: 60px;
      background: #df5813;
      line-height: 20px;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
.yellow {
  color: #df5813;
}
.batch-download-btn {
  padding: 0 20px;
  line-height: 20px;
  border-radius: 6px;
  border: 1px solid rgba(151, 151, 151, 1);
  font-size: 16px;
  font-weight: 500;
  color: rgba(58, 58, 58, 1);
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}
.batch-download-form-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 17px;
  .label {
    margin-right: 15px;
  }
}
.tips {
  margin: 20px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(128, 128, 128, 1);
  word-break: break-all;
  text-align: left;
}
</style>
